import {
    ADD_SETTINGS_FAILED,
    ADD_SETTINGS_SUCCEEDED,
    RESET_ADD_SETTINGS_STATE,
    GET_SETTINGS_STARTED,
    GET_SETTINGS_SUCCESS,
} from "../actions/types/invoice.types";

const initialState = {
    settings: {
        accountId: "",
        generalTax: 0,
        id: "",
        isShowLogo: false,
    },
    isFirstTime: false,
    fetchSettingsState: "loading",
    addSettingsState: "idle",
    settingsErrorMessage: "",
};

const invoiceSettingsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_SETTINGS_STARTED:
            return {
                fetchSettingsState: "loading",
            };

        case GET_SETTINGS_SUCCESS: {
            return {
                ...state,
                fetchSettingsState: "success",
                settings: {
                    id: payload.id || "",
                    accountId: payload.accountId || "",
                    generalTax: payload.generalTax || 0,
                    isShowLogo: payload.isShowLogo || false,
                    isAdditionalChargeAdded: payload.isAdditionalChargeAdded,
                },
                isFirstTime: payload.isFirstTime,
            };
        }

        case ADD_SETTINGS_SUCCEEDED: {
            return {
                ...state,
                addSettingsState: "success",
            };
        }

        case ADD_SETTINGS_FAILED: {
            return {
                ...state,
                addSettingsState: "failed",
                settingsErrorMessage: payload,
            };
        }

        case RESET_ADD_SETTINGS_STATE: {
            return {
                ...state,
                addSettingsState: "idle",
            };
        }

        default:
            return state;
    }
};

export { invoiceSettingsReducer };
